// loan-service's sale-document type codes (loan-service/internal/model/sale_document.go). Its
// store accepts any code of uppercase letters and digits, so a code missing here is shown as
// written rather than dropped.
const LOAN_FILE_TYPE_LABEL: Record<string, string> = {
  LOANSUM: 'Loan summary',
  NOTE: 'Note',
  MTG: 'Mortgage',
  MOD: 'Modification',
  TITLE: 'Title',
  UCC: 'UCC filing',
  APPR: 'Appraisal',
  BPO: "Broker's price opinion",
  ENV: 'Environmental report',
  INSP: 'Property inspection',
  GUAR: 'Guaranty',
  PART: 'Participation agreement',
  FIN: 'Financial statements',
  TAX: 'Tax returns',
  CREDAPP: 'Credit application',
  PAYHIST: 'Payment history',
  CORR: 'Correspondence',
  JUDG: 'Judgment',
};

const DOCUMENT_TYPE_LABEL: Record<string, string> = {
  ...LOAN_FILE_TYPE_LABEL,
  NARR: 'Pool narrative',
  BIDPKG: 'Bid package',
  TAPE: 'Data tape',
  INFO: 'Sale information',
  QALOG: 'Q&A log',
  OTHER: 'Other',
};

export const documentTypeLabel = (docType: string): string =>
  DOCUMENT_TYPE_LABEL[docType] ?? docType;

export enum DocumentTypeFilter {
  ALL = 'ALL',
  BID_PACKAGE = 'BID_PACKAGE',
  QA_LOG = 'QA_LOG',
  POOL_NARRATIVES = 'POOL_NARRATIVES',
  LOAN_FILES = 'LOAN_FILES',
}

export const DOCUMENT_TYPE_FILTERS: {
  filter: DocumentTypeFilter;
  label: string;
  docTypes?: ReadonlySet<string>;
}[] = [
  { filter: DocumentTypeFilter.ALL, label: 'All' },
  { filter: DocumentTypeFilter.BID_PACKAGE, label: 'Bid package', docTypes: new Set(['BIDPKG']) },
  { filter: DocumentTypeFilter.QA_LOG, label: 'Q&A log', docTypes: new Set(['QALOG']) },
  {
    filter: DocumentTypeFilter.POOL_NARRATIVES,
    label: 'Pool narratives',
    docTypes: new Set(['NARR']),
  },
  {
    filter: DocumentTypeFilter.LOAN_FILES,
    label: 'Loan files',
    docTypes: new Set(Object.keys(LOAN_FILE_TYPE_LABEL)),
  },
];

const filterDefinition = (filter: DocumentTypeFilter) =>
  DOCUMENT_TYPE_FILTERS.find((definition) => definition.filter === filter);

export const documentTypeFilterLabel = (filter: DocumentTypeFilter): string =>
  filterDefinition(filter)?.label ?? filter;

export const matchesDocumentTypeFilter = (filter: DocumentTypeFilter, docType: string): boolean => {
  const docTypes = filterDefinition(filter)?.docTypes;
  return !docTypes || docTypes.has(docType);
};
